// API base URL - production'da environment variable kullanılacak
export const API_BASE_URL = 'http://localhost:3000/api'

export const API_ENDPOINTS = {
  movies: {
    list: '/movies',
    detail: (id) => `/movies/${id}`,
    upcoming: '/movies/upcoming',
    past: '/movies/past',
  },
  cinema: {
    info: '/cinema/info',
  },
  library: {
    books: '/library/books',
    info: '/library/info',
  },
}
